export class SlackChannels {
    constructor() { }
    Id: string;
    ChannelId: string;
    ChannelName: string;
    TeamId: string;
    TeamName: string;
    PhoneNumber: string;
    PhoneNumberId: string;
    CreateedAt: string;
    UpdatedAt: string;
    Status: boolean;
}

export const mapToSlackChannels = (x: any): SlackChannels => {
    return {
        Id: x.id,
        ChannelId: x.channelId,
        ChannelName: x.channelName,
        TeamId: x.teamId,
        TeamName: x.teamName,
        PhoneNumber: x.phoneNumber,
        PhoneNumberId: x.phoneNumberId,
        CreateedAt: x.createdAt,
        UpdatedAt: x.updatedAt,
        Status: x.status,
    } as SlackChannels;
}